// // Product Calulator Tabs: Set Variables
// var calcTabs = $('.js-calc-tabs, .js-calc-tabs-sub-nav');
// var calcTabsHolder = $('.js-calc-tabs-holder');
// var calcTabClasses = 'printing finishing turnaround';
// var calcTabLinks = $('.js-calc-tab-link');
// var currentCalcTab = 'printing';

// // Product Calulator Tabs: Init
// calcTabs.removeClass(calcTabClasses).addClass(currentCalcTab);
// calcTabLinks.removeClass('active');
// $('.js-calc-tab-link[data-tab-group="'+currentCalcTab+'"]').addClass('active');

// // Product Calulator Tabs: Navigate
// calcTabLinks.click(function(event) {
//     var clickedCalcTabLink = $(this);
//     var targetCalcTab = clickedCalcTabLink.data('tab-target');
//     var targetCalcTabLinks = $('.js-calc-tab-link[data-tab-group="'+targetCalcTab+'"]');

//     if ( currentCalcTab == targetCalcTab ) { }
//     else {
//         calcTabsHolder.stop(true,true).animate({ opacity:0 }, 500, function() {
//             currentCalcTab = targetCalcTab;
//             calcTabs.removeClass(calcTabClasses).addClass(targetCalcTab);
//             calcTabLinks.removeClass('active');
//             targetCalcTabLinks.addClass('active');
//             calcTabsHolder.css({ opacity:0, display:'block' }).animate({ opacity:1 }, 500);
//         });
//     }
//     event.preventDefault();
// });

// Product Calculator Dynamic Instant Quote Table
var cu = window.calcUtil; //shortcut for accessing helper utils
let optionsOpen = false;

function updateProofDD () {
    const dd = document.querySelector('select[name="PROOFDD"]');

    if (!dd) {
        return;
    }

    const noProofOption = dd.querySelector('option[value="58"]');
    const noSoftOption = dd.querySelector('option[value="1"]');
    const noel = document.createElement('div');

    (noProofOption || noel).innerText = `No Proof Needed (quickest)`;
    (noSoftOption || noel).innerText = `PDF Soft Proof (adds small delay)`;
}

var wspMagic = {
    onCalcLoaded: function(product) {
        // console.log('onCalcLoaded > product', product)
       //one time changes that happen only on initial load...
       //calcWasModified=-1;
       //console.log('onCalcLoaded > LFsubstrateSizes',LFsubstrateSizes);
       //console.log('onCalcLoaded > LFsubstrateSizes[5]',LFsubstrateSizes[5]);
       //console.log('product',JSON.stringify(product));
       //$("#dimensions label.config").append(" *");
       //console.log('calculatorValidation',JSON.stringify(calculatorValidation)); // talk to Matt about calculatorValidation access
        this.showJobQuotePrices();
        if (!document.body.classList.contains('my-products-product-page')) {
            this.constructTurnaroundContainer();
            this.windowClingConfig();
        }
        this.removeEmptyElements();
        this.removeLoader();
        this.estimatedPostage();
        this.promoCalcUpdate();
        this.turnaroundProofGraphic();
        this.checkForProofSampleSheet();
        this.ABBusinessTest();
        this.helpIconTabInteraction();
    },
    onCalcChanged: function(updates, product) {
        // console.log('onCalcChanged > product', product)
        // console.log('onCalcChanged > updates', updates)
        this.enableLoader();
        // when the calc changes, before the updates gets sent to the server...
        //console.log('onCalcChanged > LFsubstrateSizes',LFsubstrateSizes);
        // console.log('Changed updates',JSON.stringify(updates));
        //$("#dimensions label.config").append(" **");
        this.estimatedPostage();
        this.promoCalcUpdate();
        this.turnaroundProofGraphic();
        this.checkForProofSampleSheet();
        this.ABBusinessTest();
        this.helpIconTabInteraction();
    },
    onQuoteUpdated: function(updates, validation, product) {
        // console.log('onQuoteUpdated > product', product)
        // console.log('onQuoteUpdated > updates', updates)
        // console.log('onQuoteUpdated > validation', validation)
        /* when the updated quote returns from the server... */
        // only execute if the product is print on demand
        if (cu.isPOD(product)) {

            // calcWasModified++;
            //console.log('calcWasModified',calcWasModified);

            /*re-init on every update -- this puts all visible fields in the fields object*/
            cu.initFields();

            // ************************** copy the price to another element
            //this.copyPrice();

            // ************************** generate job summary
            this.generateJobSummary();


            // ************************** some other magic you want to summon...
            //alert("Magic just came back from the server and it smells like pickles.");

        }// end is POD
        // console.log('Updated updates',JSON.stringify(updates));
        this.moveStaticCLingsOperation();
        this.copyPrice();
        this.removeLoader();
        this.quantitySets();
        this.earliestDelivery();
        cu.isPOD(product) && common.offeringId === 2 && updateProofDD();

    },
    helpIconTabInteraction(){
        setTimeout(() => {
            document.querySelectorAll('.quoteHelp').forEach( e => {
                e.setAttribute('tabindex', 0)
            })
        }, 500)
    },
    copyPrice: function() {
        var originalPrice = document.querySelector('tr.productPrice td span.lineItemPrice') ? document.querySelector('tr.productPrice td span.lineItemPrice').innerText : '--';
        var discountedPrice = document.querySelector('tr.productPrice.discounted td span.lineItemPrice');

        if (originalPrice == '') {
            originalPrice = '--';
        }

        if (discountedPrice !== null) {
            discountedPrice = discountedPrice.innerText;
            $('#productTotalCost').text(''+discountedPrice);
            $('#productOriginalPrice').removeClass('isHidden');
            $('#productOriginalPrice > span').text(''+originalPrice);
        } else {
            $('#productTotalCost').text(''+originalPrice);
            $('#productOriginalPrice').remove();
        }
    },
    generateJobSummary: function() {
        // empty stringified array

        var desc= '';
        var currentSubstrateID = '';
        var currentSubstrateSize = '';
        var tableArr = new Array();
        $("#dynamic_config_content").empty();
        $("#debug").empty();
        var values = {};
        var calculatorType = calculatorType;

        // bug/break fix
        //console.log('generateJobSummary called');
        //var theform = $('form[name="theform"]').serializeArray();console.log('theform',theform);
        //var theform = $("#calculator .generalCalculator :input").serializeArray();console.log('theform',theform);

        //var theform = $('form[name="theform"]').serializeArray();console.log('theform',theform);
        calculatorType='small';
        //console.log('lf Calculator:',$( "#lfCalculator" ).length) ;
        //console.log('sf Calculator:',$( "#calculator" ).length) ;
        if ( $( "#lfCalculator" ).length ) {
            calculatorType='large';
        }
        if ( calculatorType == 'small' ) {
            var theform = $("#calculator :input").not('.excludeFromReview').serializeArray();//console.log('theform',theform);
        }else{
            var theform = $("#lfCalculator :input").not('.excludeFromReview').serializeArray();
            //#lfCalculator .generalCalculator
            //console.log('theform',theform);
        }

        //console.log(calculatorType);

        $.each(theform, function(i, field) {
        //$.each($('form[name="theform"]').serializeArray(), function(i, field) {
            var desc = $('[name="' + field.name + '"] option:selected').text();
            var parentid = $('[name="' + field.name + '"]').closest("div").attr("id");
            //console.log('parentid',parentid);
            //var labeltext = $('[name="' + field.name + '"]').closest('div').find('label').text();
            var labeltext = $('[name="' + field.name + '"]').closest('div').find('label.config').text(); // opQuestion vs config
            //console.log('p:'+parentid,'p:'+desc,'p:'+labeltext);
            //console.log('field',field);
            //console.log('field.name',field.name);
            if ( field.name == 'PRINTSUBSTRATEDD' ) {
                currentSubstrateID = field.value ;
                // console.log('currentSubstrateID:',currentSubstrateID);
                // currentSubstrateSize = LFsubstrateSizes[currentSubstrateID];
                // console.log('currentSubstrateSize:',currentSubstrateSize);
                // default: Finished Size in Inches (W x H)
                // replace: Finished Size W"xH" - Max for this Substrate: 60x120
                // $("#dimensions label.config").empty().append('Finished Size W"xH" - Max for this Substrate: <em><strong>'+currentSubstrateSize+'</strong></em>');
            }
            /*
            console.log('field',field);
            // these are somehow part of the calc form...?
            field Object {name: "Name", value: "Eric ..."}
            field Object {name: "Email", value: "....@thebernardgroup.com"}
            field Object {name: "Phone", value: ""}
            field Object {name: "Business Name", value: ""}
            field Object {name: "Website", value: ""}
            field Object {name: "Address", value: ""}
            field Object {name: "City", value: ""}
            field Object {name: "State", value: ""}
            field Object {name: "Zip Code", value: ""}
            field Object {name: "Country", value: "United States"}
            field Object {name: "Business Type", value: ""}
            field Object {name: "Trade Membership or Affiliation", value: ""}
            field Object {name: "Additional Comments", value: ""}
            */
            if (/object|pageaction|sourcepage|uname|pwd/i.test(field.name)) {
                // debug
            }else{
                if (/none/i.test(desc)) {
                    // debug
                    // console.log('test(desc)',desc);
                }else{
                    if ( desc == '' ){
                        //desc = field.name+':'+field.value+':'+parentid ;
                        desc = field.value ;
                    }
                    if ( labeltext == '' ){
                        if (/height/i.test(field.name)) {
                            labeltext = 'Height (Inches)';
                        }
                        if (/width/i.test(field.name)) {
                            labeltext = 'Width (Inches)';
                        }
                        if (/zip/i.test(field.name)) {
                            labeltext = 'Shipping Zip';
                        }
                        if (/location/i.test(field.name)) {
                            labeltext = 'Shipping Country';
                        }
                    }

                    if (/states/i.test(desc)) {
                        labeltext = 'Shipping Country';
                    }

                    //console.log('l:'+labeltext,'d:'+desc,'field.name:'+field.name);
                    // filter out pre-populated form Name & Email
                    if ( desc != '' && field.name != 'Name' && field.name != 'Email' ) {

                        //console.log('l:'+labeltext,'d:'+desc,'field.name:'+field.name);
                        $('#dynamic_config_content').append('<tr><th scope="row" class="lbl lbl_sm lbl_bold">'+labeltext+'</th><td class="lbl lbl_serif lbl_lowercase">'+desc+'</td></tr>');
                    }

                    tableArr[labeltext] = desc ;
                }
            }

        });
    },
    // Dont show pricing area unless the user has a discount
    showJobQuotePrices: function () {
        if ($('#jobQuotePrices tr.discounted').length > 0) {
            $('#jobQuotePrices').show()

            var startingOriginalPrice = document.querySelector('tr.productPrice td span.lineItemPrice').innerText;
            $('#origStartPrice').text(''+startingOriginalPrice);
        }
    },

    constructTurnaroundContainer: function(){
        const turnAroundContainer = document.getElementById('productionSettings');
        const addToCartBtnContainer = document.querySelector('.quoteContinue');
        const turnaroundInfo = document.querySelector('.js-turnaroundProcessEle');
        const costContainer = document.querySelector('.js-costContainerEle');
        const continueButton = document.querySelector('.continueButton, .addToCart');
        const viewTarget = document.createElement('div');

        viewTarget.classList.add('js--element-viewTarget');
        continueButton.classList.add('btn','btn_cta');

        const newElements = [
            turnaroundInfo,
            viewTarget,
            costContainer
        ];

        newElements.forEach(el => {
            if (el === null) {
                return;
            }
            if (document.getElementById('calculator') || document.getElementById('lfCalculator')) {
                turnAroundContainer.appendChild(el);
            }
            if (document.getElementById('stockCalculator')) {
                document.getElementById('quantity').append(el);
            }
            if (document.getElementById('calculator')) {
                turnAroundContainer.appendChild(el);
            }
        })

        costContainer && costContainer.appendChild(addToCartBtnContainer);

        if (window.screen.width <= 1023) {
            return;
        } else {
            initStickyCostContainer();
        }

        function initStickyCostContainer () {
            let callback = (entry, observer) => {
                if (entry[0].isIntersecting) {
                    costContainer.classList.remove('isOutOfView');
                    return;
                } else if (viewTarget.getBoundingClientRect().top > 0) {
                    costContainer.classList.add('isOutOfView');
                    return;
                }
            };
            let observer = new IntersectionObserver(callback, { threshold: [0] });

            observer.observe(viewTarget);
        }
    },

    windowClingConfig: function () {
        const configContainer = document.querySelector('.js-windowClingContainerEle');
        if (!configContainer) {
            return;
        }
        const calcColumn = document.getElementById('lfCalculator');

        calcColumn.prepend(configContainer);
    },

    removeEmptyElements: function () {
        const largeFormatCalc = document.getElementById('lfCalculator');

        if (!largeFormatCalc) {
            return;
        }

        const elements = [document.getElementById('lfConstruction'), document.getElementById('lfVariousSettings'), document.getElementById('operationsDiv')]

        elements.forEach(el => {
            if(el?.innerHTML.trim().length == 0) {
                el.remove();
            }
        })

    },

    moveStaticCLingsOperation: function () {
        // Static Window Cling Ink Selection Operation DOM update
        const materialOperation = document.querySelector('#duplicateoperation89.optionWrapperOn');
        const inkSelectionOperation = document.querySelector('#duplicateoperation348.optionWrapperOn');

        if (!inkSelectionOperation) {
            return;
        }
        if (document.body.classList.contains('SLS_77299')) {
            materialOperation.after(inkSelectionOperation);
        };
    },

    enableLoader: function () {
        document.querySelector('.js--element-generalCalculator') && document.querySelector('.js--element-generalCalculator').classList.add('isDelayed')
    },

    removeLoader: function () {
        document.querySelector('.js--element-generalCalculator') && document.querySelector('.js--element-generalCalculator').classList.remove('isDelayed')
    },

    quantitySets: function () {
        if (ABTest('test-stepped-quantity-2')) {
            const calcQtyContainer = document.querySelector('input[name=QUANTITYEF]');
            const setQtySelect = document.createElement('select');
            const optionsArray = [25,50,75,100,150,200,250,500,750,1000,1250,1500,2000,2500,3000,3500,4000,4500,5000,6000,7000,8000, 9000,10000,12500,15000,20000,30000,40000,50000,60000,70000,80000,90000,100000];

            setQtySelect.classList.add('qtyDropdown');
            calcQtyContainer.style.display = 'none';
            calcQtyContainer.insertAdjacentElement('afterend', setQtySelect);
            optionsArray.forEach(val => {
                const option = document.createElement('option');
                option.value = val;
                option.text = val;
                setQtySelect.add(option);
            })

            let selectedQtyOption = setQtySelect[0].value;
            let selectedQtyOptionIndex = 0;

            if (optionsArray.includes(parseInt(calcQtyContainer.value))) {
                selectedQtyOption = calcQtyContainer.value;
                selectedQtyOptionIndex = optionsArray.indexOf(parseInt(calcQtyContainer.value));
            }

            if (!fields.quantityPerVersion) {
                setQtySelect[selectedQtyOptionIndex].selected = true;
                cu.changeField(fields.quantity, selectedQtyOption, true);
                setQtySelect.addEventListener('change', (e)=> { cu.changeField(fields.quantity, e.target.value, true); });
                return;
            }

            if (fields.quantityPerVersion) {
                calcQtyContainer.style.display = 'table-row';
                setQtySelect.style.display = 'none';
            }
        }
    },
    earliestDelivery: function () {
        if (!configureglobals.coffering || !document.querySelector('.js-element--earliestDelivery')) {
            return;
        }

        const dateStr = !configureglobals.coffering.earliestDeliveryDate ? configureglobals.coffering.systemOffering.earliestDeliveryDate : configureglobals.coffering.earliestDeliveryDate;

        if (dateStr.length < 0) {
            return;
        }

        const earliestDeliveryEle = document.querySelector('.js-element--earliestDelivery');
        const modalEarliestDeliveryDateEle = document.querySelector('.js-element--earliestDeliveryDateModal');
        const date = new Date(`${dateStr}T00:00:00`);
        const deliveryDate = `${date.toLocaleDateString('en-US', { month: 'long' })} ${date.toLocaleDateString('en-US', { day: 'numeric' })}`;
        const deliveryDateDay = `${date.toLocaleDateString('en-US', { weekday: 'short' })}`

        earliestDeliveryEle.style.display = 'inline-block'
        earliestDeliveryEle.innerHTML = `Get it as soon as <strong>${deliveryDateDay}, ${deliveryDate}</strong>. <span class="chip-link">Here's how</span>`;
        modalEarliestDeliveryDateEle.innerHTML = deliveryDate;

    },
    estimatedPostage: function () {
        if( document.body.classList.contains('SLS_33964') || //Direct Mail Postcards
            document.body.classList.contains('SLS_80257') || //Religious Direct Mail Postcards
            document.body.classList.contains('SLS_79638') || //Nonprofit Direct Mail Postcards
            document.body.classList.contains('SLS_79187') || //Restaurant Direct Mail Postcards
            document.body.classList.contains('SLS_82786') || //Real Estate Direct Mail Postcards
            document.body.classList.contains('SLS_78950')    //School Direct Mail Postcards
        ) {

            if( document.querySelector('.turnaroundTime-message__note') ) {
                document.querySelector('.turnaroundTime-message__note').style.display = "none";
            }
            document.querySelector('.estimatedPostage').style.display = "grid";

            let mailUnitClass = document.querySelector('select[name=OPERATIONDD5]').value;
            let mailUnitQuantity = document.querySelector('input[name=QUANTITYEF]').value;
            let mailUnitWeight = document.querySelector('select[name=PRESSSHEETWEIGHTDD]').value;
            let mailUnitDimension = document.querySelector('select[name=PRESETDIMENSIONSDD]');
            let mailUnitRate = 0;
            let postageTarget = document.querySelector('.estimatedPostage__units__cost') ;
            let rateTarget = document.querySelector('.estimatedPostage__units__rate') ;
            let classTarget = document.querySelector('.estimatedPostage__units__class');
            const captureDimension = new Map ( [
                ['674', false], // 6x9
                ['675', true],  // 6x11
                ['672', false], // 4.25 x 6
                ['673', false], // 4x6
                ['723', false], // 5.5x8.5
                ['724', false], // 5x7
                ['1110', false],// 6x4
                ['1111', false],// 6x4.25
                ['1112', false],// 7x5
                ['1113', false],// 8.5x5.5
                ['1114', false],// 9x6
                ['1115', true]  // 11x6
            ] );
            const captureClassOption = new Map( [
                ['1651', 'First class Mailing'],
                ['1654', 'Standard Mailing'],
                ['1653', 'Non-Profit Mailing']
            ] )

            const calculatePostageEst = () => {
                postageTarget.innerText = (mailUnitQuantity * (Math.round((mailUnitRate + Number.EPSILON) * 100 ) / 100)).toLocaleString("en", { minimumFractionDigits: 2 })
                rateTarget.innerHTML = `Unit Rate: ${mailUnitRate}`
                classTarget.innerHTML = captureClassOption.get(mailUnitClass)
            };

            const disableEstimatedPostage = () => {
                document.querySelector('.estimatedPostage').style.display = "none"
                document.querySelector('.turnaroundTime-message__note').style.display = "block"
            };

            if(mailUnitWeight === '30') {
                mailUnitClass = '1651'
            };

            if( captureDimension.get(mailUnitDimension.value) ) {
                //over size
                if( mailUnitClass === '1651' ) {
                    //1st class
                    if(mailUnitQuantity <= 199 ) {
                        mailUnitRate = 0.78
                    } else {
                        mailUnitRate = 0.707
                    }
                }
                else if ( mailUnitClass === '1652' ) {
                    //list processing
                    disableEstimatedPostage();
                }
                else if( mailUnitClass === '1653' ) {
                    //non-profit
                    if( mailUnitQuantity <= 199 ) {
                        //mailUnitRate = 0.73
                        disableEstimatedPostage();
                    } else {
                        mailUnitRate = 0.257
                    }
                }
                else {
                    //standard
                    if( mailUnitQuantity <= 199 ) {
                        mailUnitRate = 0.65
                    } else {
                        mailUnitRate = 0.467
                    }
                }
                calculatePostageEst();
            } else {
                //under size
                if ( mailUnitClass === '1652' ) {
                    //list processing
                    disableEstimatedPostage();
                } else {
                    if( mailUnitQuantity <= 499 ) {
                        mailUnitRate = 0.65
                    } else {
                        mailUnitRate = 0.492
                    }
                }
                calculatePostageEst();
            }

            if (
                document.querySelector('select[name=OPERATIONDD5]').value == '1651' && mailUnitDimension.value == '1110' && mailUnitWeight == '8' ||
                document.querySelector('select[name=OPERATIONDD5]').value == '1651' && mailUnitDimension.value == '1110' && mailUnitWeight == '9' ||
                document.querySelector('select[name=OPERATIONDD5]').value == '1651' && mailUnitDimension.value == '1111' && mailUnitWeight == '8' ||
                document.querySelector('select[name=OPERATIONDD5]').value == '1651' && mailUnitDimension.value == '1111' && mailUnitWeight == '9' ||
                document.querySelector('select[name=OPERATIONDD5]').value == '1651' && mailUnitDimension.value == '1112' && mailUnitWeight == '8' ||
                document.querySelector('select[name=OPERATIONDD5]').value == '1651' && mailUnitDimension.value == '1112' && mailUnitWeight == '9' ||
                document.querySelector('select[name=OPERATIONDD5]').value == '1651' && mailUnitDimension.value == '1113' && mailUnitWeight == '8' ||
                document.querySelector('select[name=OPERATIONDD5]').value == '1651' && mailUnitDimension.value == '1113' && mailUnitWeight == '9' ||
                document.querySelector('select[name=OPERATIONDD5]').value == '1651' && mailUnitDimension.value == '674' && mailUnitWeight == '8' ||
                document.querySelector('select[name=OPERATIONDD5]').value == '1651' && mailUnitDimension.value == '674' && mailUnitWeight == '9'
            ) {
                mailUnitRate = 0.492
                calculatePostageEst();
            } else if (
                document.querySelector('select[name=OPERATIONDD5]').value == '1651' && mailUnitDimension.value == '1110' && mailUnitWeight == '30' ||
                document.querySelector('select[name=OPERATIONDD5]').value == '1651' && mailUnitDimension.value == '1111' && mailUnitWeight == '30' ||
                document.querySelector('select[name=OPERATIONDD5]').value == '1651' && mailUnitDimension.value == '1112' && mailUnitWeight == '30' ||
                document.querySelector('select[name=OPERATIONDD5]').value == '1651' && mailUnitDimension.value == '1113' && mailUnitWeight == '30' ||
                document.querySelector('select[name=OPERATIONDD5]').value == '1651' && mailUnitDimension.value == '674' && mailUnitWeight == '30'
            ) {
                mailUnitRate = 0.707
                calculatePostageEst();
            } else if (
                document.querySelector('select[name=OPERATIONDD5]').value == '1651' &&
                mailUnitDimension.value == '1114' &&
                mailUnitWeight == '30' &&
                document.querySelector('input[name=QUANTITYEF]').value <= 499
            ){
                mailUnitRate = 0.78
                calculatePostageEst();
            }
            else if ( document.querySelector('select[name=OPERATIONDD5]').value == '1654' ) {
                mailUnitRate = 0.467
                if( mailUnitQuantity < 200 ) {
                    document.querySelector('input[name=QUANTITYEF]').value = '200'
                    mailUnitQuantity = 200
                }
                calculatePostageEst();
            } else if ( document.querySelector('select[name=OPERATIONDD5]').value == '1653') {
                if(document.querySelector('input[name=QUANTITYEF]').value > 499 && !captureDimension.get(mailUnitDimension.value)) {
                    mailUnitRate = 0.419
                } else {
                    mailUnitRate = 0.257
                }

                if( mailUnitQuantity < 200 ) {
                    document.querySelector('input[name=QUANTITYEF]').value = '200'
                    mailUnitQuantity = 200
                }
                calculatePostageEst();
            }
        }
    },
    promoCalcUpdate: function () {
        if( !configureglobals.coffering || !configureglobals.coffering.productionGroup.name ) return

        if( configureglobals.coffering.productionGroup.name === 'Promo' ) {
            document.getElementById('dimensions').style.display = "none"
            document.getElementById('quantity').style.width = "100%"

            if( !!document.querySelector('.shipping-estimate-link') ) {
                document.querySelector('.shipping-estimate-link').parentElement.style.display = "none"
            }
        }
    },
    turnaroundProofGraphic: function () {
        if (!document.querySelector('select[name=PROOFDD]') || !document.getElementById('turnaroundGraphic-step--no-proof')) {
            return;
        }

        let proofSelection = document.querySelector('select[name=PROOFDD]').value;

        if( proofSelection === '1' || proofSelection === '4' || proofSelection === '8' || proofSelection === '12') {
            document.querySelector('#turnaroundGraphic-step--no-proof').style.display = "none";
            document.querySelector('#turnaroundGraphic-step--proof').style.display = "flex";
        } else {
            document.querySelector('#turnaroundGraphic-step--no-proof').style.display = "flex";
            document.querySelector('#turnaroundGraphic-step--proof').style.display = "none";
        }
    },
    checkForProofSampleSheet: function () {
        //proofSampleSheet
        if( !document.querySelector('select[name=PROOFDD]') || !configureglobals.coffering.productionGroup.name ) return

        if( configureglobals.coffering.productionGroup.name.includes('Small Format') && document.getElementById('proofProductionTime')) {
            document.getElementById('proofProductionTime').append(document.querySelector('.productionGroup'))
            document.querySelector(' #proofProductionTime').style.display = "block"
        }
    },
    ABBusinessTest: function () {
        const params = new URLSearchParams(window.location.search);
        const isReordered = params.has('reorder');
        const isSharedConfig = params.get('sharedProductConfig');

        if (!isReordered && !isSharedConfig && ABTest('test-calc-mods')) {
            document.body.classList.add('testCalcMods');
            Array.prototype.slice.call( document.querySelector('select[name="OPERATIONDD11"]').options ).forEach( e => {
                if( e.innerText === 'Round corners - 3/8"' ) {
                    e.remove()
                }
            });
        };
    },
    // One half of an AB test around the SI button on PDP,
    // the other half of the test exists in product.html, search for 'pdp-si-button'
    ABSIButton: function (product) {
        if (cu.isPOD(product) && ABTest('pdp-si-button') && !window.location.href.includes('demo') && !window.location.href.includes('create-new-product'))  {
            const calc = document.getElementById('calculator') || document.getElementById('lfCalculator');
            const div = document.createElement('div');
            div.style.textAlign = 'center';
            div.style.paddingTop = '15px';
            div.innerHTML = `
                <button
                    id="smartpress-ai-configure-button"
                    class="smartpress-ai-button aiBtnWrapper"
                    onclick="gutenberg.recordProductButtonClicked();gutenberg.open();"
                    style="
                        position: relative;
                        left: auto;
                        bottom: auto;
                        transform: none;
                        transition: none;
                        border-radius: 32px;
                        padding: 0;
                        border: 0;
                        background: none;
                        color: white;
                    "
                >
                    <div class="aiBtnDecorator"></div>
                    <div class="aiBtnBuffer">
                        <div class="aiBtnInnerWrapper">
                            <div class="aiBtnFlexWrapper">
                                <div class="aiBtnIcon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none" style="width: 100%; height: 100%;">
                                        <g clip-path="url(#clip0_5741_4025)">
                                            <path d="M8.89988 16.5402C8.55988 16.5402 8.26488 16.3102 8.17488 15.9852L7.48488 13.4002C6.99988 11.5952 5.57988 10.1702 3.76988 9.68524L1.18488 8.99524C0.854883 8.90524 0.629883 8.61024 0.629883 8.27024C0.629883 7.93024 0.859883 7.63524 1.18488 7.54524L3.76988 6.85524C5.57488 6.37024 6.99988 4.95024 7.48488 3.14024L8.17488 0.555244C8.26488 0.225244 8.55988 0.000244141 8.89988 0.000244141C9.23988 0.000244141 9.53488 0.230244 9.62488 0.555244L10.3149 3.14024C10.7999 4.94524 12.2199 6.37024 14.0299 6.85524L16.6149 7.54524C16.9449 7.63524 17.1699 7.93024 17.1699 8.27024C17.1699 8.61024 16.9399 8.90524 16.6149 8.99524L14.0299 9.68524C12.2249 10.1702 10.7999 11.5902 10.3149 13.4002L9.62488 15.9852C9.53488 16.3152 9.23988 16.5402 8.89988 16.5402ZM4.27488 8.27024C6.50488 8.91024 8.25988 10.6652 8.89988 12.8952C9.53988 10.6652 11.2949 8.91024 13.5249 8.27024C11.2949 7.63024 9.53988 5.87524 8.89988 3.64524C8.25988 5.87524 6.50488 7.63024 4.27488 8.27024Z" fill="white"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_5741_4025">
                                                <rect width="16.54" height="16.54" fill="white" transform="translate(0.629883 0.000244141)"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <div class="aiBtnLabel">Configure with Smartpress Intelligence</div>
                            </div>
                        </div>
                    </div>
                </button>
            `;
            calc.prepend(div);
        }
    }
}

// register each of the event listeners...
configureEvents.registerOnCalcLoadedListener(wspMagic);
configureEvents.registerOnCalcChangedListener(wspMagic);
configureEvents.registerOnQuoteUpdatedListener(wspMagic);
